import React, { useEffect, useState } from 'react'
import Footer from '../../../components/Footer/Footer'
import { AuthenticatedHeader } from '../../../components/Header/AuthenticatedHeader'
import classes from './BrowseClasses.module.css'
import gridClasses from '../../../styles/grid.module.css'
import ToggleBar from '../../../components/ToggleBar/ToggleBar'
import classNames from 'classnames'
import { ClassCard } from '../../../components/Cards/GeneralCard/Card'
import PageChanger from '../../../components/PageChanger/PageChanger'
import { useDispatch, useSelector } from 'react-redux'
import { categoriesSelectors } from '../../Course/categoriesSlice'
import notification from '../../../components/Notification/notification'
import { getCategories } from '../../Course/categoriesApi'
import { browseClassesSelectors } from './browseClassesSlice'
import { getClasses } from './browseClassesApi'
import CardLoader from '../../../components/loaders/CardLoader'
import { getImageURL } from '../../../util/functions'
import placeholder from '../../../assets/images/class-placeholder.svg'
import empty from '../../../assets/images/empty-class.svg'
import Empty from '../../../components/Empty/Empty'

const BrowseClasses = () => {
    const dispatch = useDispatch()

    //Categories Logic
    const [activeCategory, setActiveCategory] = useState(null)
    const categories = useSelector(categoriesSelectors.categories)
    const categoriesHasError = useSelector(categoriesSelectors.hasError)
    const categoriesErrorMessage = useSelector(categoriesSelectors.errorMessage)
    const categoriesIsFetching = useSelector(categoriesSelectors.isFetching)

    useEffect(() => {
        if (!categoriesIsFetching && categoriesHasError) {
            notification.failure({
                title: 'Something went wrong with fetching categories',
                description: categoriesErrorMessage,
            })
        }
    }, [categoriesIsFetching])

    const [page, setPage] = useState(1)

    const fetchClasses = () => {
        dispatch(
            getClasses({ catId: activeCategory, pageNo: page, pageSize: 10 })
        )
    }

    const isFetching = useSelector(browseClassesSelectors.isFetching)
    const errorMessage = useSelector(browseClassesSelectors.errorMessage)
    const hasError = useSelector(browseClassesSelectors.hasError)
    const classesArray = useSelector(browseClassesSelectors.classes)
    const paging = useSelector(browseClassesSelectors.paging)

    useEffect(() => {
        if (!isFetching && hasError) {
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }
    }, [isFetching])

    useEffect(() => {
        dispatch(getCategories('classes'))
        fetchClasses()
    }, [])

    useEffect(() => {
        fetchClasses()
    }, [page, activeCategory])

    return (
        <>
            <AuthenticatedHeader />
            <div className={classes.top}>
                <div
                    className={classNames(
                        gridClasses.container,
                        gridClasses.containerTransparent
                    )}
                >
                    <ToggleBar
                        links={categories}
                        activeId={activeCategory}
                        changeActive={setActiveCategory}
                        loading={categoriesIsFetching}
                    />
                </div>
            </div>
            <main className={gridClasses.container}>
                <h3 className={classes.classesHeader}>
                    {categories.find(({ id }) => id === activeCategory)?.text}
                </h3>
                <div className={classes.classesGrid}>
                    {isFetching ? (
                        <>
                            <CardLoader />
                            <CardLoader />
                            <CardLoader />
                        </>
                    ) : (
                        classesArray.map(classObj => (
                            <ClassCard
                                url={
                                    classObj.thumbnail
                                        ? getImageURL(classObj.thumbnail)
                                        : placeholder
                                }
                                category={classObj.catName}
                                attendees={classObj.enrolled}
                                {...classObj}
                                key={classObj.classid}
                                classid={classObj.classid}
                                className={classes.class}
                                date={classObj.startdate}
                                time={classObj.starttime}
                            />
                        ))
                    )}
                </div>
                {!isFetching && classesArray.length === 0 && (
                    <Empty icon={empty} text={'No Classes Found'} />
                )}
                {!isFetching && classesArray.length > 0 && (
                    <div className={classes.pageChangerWrapper}>
                        <PageChanger
                            pageCount={paging.pageCount}
                            onPageChange={setPage}
                            currentPage={page}
                        />
                    </div>
                )}
            </main>
            <Footer />
        </>
    )
}

export default BrowseClasses
